<template>
  <!--in-center *search*  -->
  <form
    :class="`
    absolute  ${showSearch ? 'flex' : 'hidden'} top-[92px] left-[50%] -translate-x-1/2 -translate-y-1/2  w-[90%]     flex-1 items-center h-full  
    sm:relative z-[5] sm:z-auto sm:mr-[4.5rem] sm:ltr:mr-0 sm:ltr:ml-[4.5rem]  sm:flex sm:flex-1 sm:items-center sm:h-full sm:p-0 sm:top-auto sm:left-auto sm:-translate-x-0 sm:translate-y-0 
    `"
    @submit.prevent="submitSearch"
    
    >
    <!-- buttons container -->
    <span class="absolute left-12 ltr:left-auto ltr:right-12 w-[15px] ">
      <!-- loading suggestions indicator -->
      <span v-if="isLoadingSuggestions" aria-label="loading search suggestions">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="white" d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z" opacity="0.5"/><path fill="white" d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z"><animateTransform attributeName="transform" dur="1s" from="0 12 12" repeatCount="indefinite" to="360 12 12" type="rotate"/></path></svg>
      </span>
      <!-- clear search -->
      <button
        v-else-if="!searchInpt == ''"
        type="button"
        @mousedown="searchInpt = ''"
        aria-label="search search"
        class="inline-flex items-center rounded-[5px] cursor-pointer">
        <img src="@/assets/navBar/burger-menu-close.svg" class="w-fit" alt="" />
      </button>
    </span>


    <!-- input search -->
    <input
    id="app-search-input"
    @keyup.enter="handleEnterKey"
      :value="searchInpt"
      @input="(e) => {
        searchInpt=e?.target?.value
        handleSuggestions()
      }"
      @click="navigateToSearchPage"
      @focus="showSuggestionsList=true "
      @blur="()=>{
        showSuggestionsList = false; 
        //closeSearchBar()
      }"
      ref="searchInput"
      type="text"
      :class="`w-full rtl:mr-auto rtl:ml-0 ltr:ml-auto ltr:mr-0 px-3 xl:px-4 2xl:px-5 py-2.5 rounded-none border-none rounded-r-[5px] ltr:rounded-r-none ltr:rounded-l-[5px] bg-[#0758E7] outline-none focus:border-2 focus:border-[#d0dcee] block font-normal text-[14px] xl:text-[14.5px] tex text-[white] placeholder:text-[#9fbef6] ${this?.$route?.path != '/search' && 'cursor-pointer'}`"
      :placeholder="$t('user.header.search_for')" />

    <!-- search button -->
    <button
    :disabled="isLoading"
    @click="navigateToSearchPage"
      type="submit"
      :aria-label="$t('general.search')"
      :aria-labelledby="$t('general.search')"
      class="inline-flex items-center w-[40px] min-w-[40px] p-2.5 select-none text-sm text-gray-900 bg-[#ffffff] border-0 border-r-0 rounded-l-[5px] ltr:rounded-l-none ltr:rounded-r-[5px] cursor-pointer disabled:opacity-60">
      <img src="@/assets/navBar/search.svg" class="object-fit" alt="" />
      <span class="sr-only">{{ $t('general.search') }}</span>
    </button>

    <!-- suggestions for search -->
    <!-- <ul
      v-if="showSuggestionsList && suggestions.length"
      class="absolute top-[calc(39px+11px)]  sm:top-[39px] max-h-[300px] overflow-y-auto h-fit w-full flex flex-col gap-1 overflow-hidden rounded-[0_0_10px_10px] border-gray-100 bg-white"
      style="box-shadow: 0px 0px 10px rgba(164, 164, 164, 0.737);"
    > -->
      <!-- suggestions at loading -->
      <!-- <li v-show="isLoadingSuggestions"
        v-for="(item, indx) in Array(3)"
        :key="indx"
        :class="`px-2 py-3 ${Array(3).length - 1 == indx ? '' : 'border-b-2'} hover:shadow-[1px_2px_5px_#c1c1c132] hover:scale-[.995] duration-75 hover:rounded-md flex justify-between items-center border-gray-100 relative cursor-pointer hover:bg-yellow-50 hover:text-gray-900`"
        >
        <p class="text text-start self-start max-w-[90%]">
          {{`${formattedInput(searchInpt)} ${$t('general.in')}` }}
          <span class="bg-[#c1c1c132] mx-1 animate-pulse rounded-md px-[2.4em] py-[.05em]">
          </span>
        </p>
        <svg class="w-5 h-5" fill="#6c6c6c" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 24 24">
          <path
            d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z"></path>
        </svg>
      </li> -->
      <!-- <li v-show="!isLoadingSuggestions"
        v-for="(suggestion, indx) in suggestions"
        :key="indx"
        @mousedown="() => redirectToFilterPage(suggestion)"
        :class="`px-2 py-3 ${suggestions.length - 1 == indx ? '' : 'border-b-2'} hover:bg-[#c5c5c50e]  hover:shadow-[1px_2px_5px_#c1c1c132] hover:scale-[.995] duration-75 hover:rounded-md flex justify-between items-center border-gray-100 relative cursor-pointer hover:bg-yellow-50 hover:text-gray-900`"
        >
        <section class="text text-start self-start max-w-[90%]  flex flex-wrap items-center gap-2">
          
          <span>{{suggestion?.search}}</span>

          <span>{{$t('general.in')}}</span>
          <span class="bg-[#c1c1c132] rounded-md px-[.17em] py-[.02em] text-sm font-semibold whitespace-nowrap">
            {{ suggestion?.name_en&&suggestion[nameKey] }}
          </span>

          <span v-if="suggestion?.name_en==='Other'">{{$t('general.in')}}</span>
          <span v-if="suggestion?.name_en==='Other'" class="bg-[#c1c1c132] rounded-md px-[.17em] py-[.02em] text-sm font-semibold whitespace-nowrap">
            {{ suggestion?.parent?.name_en&&suggestion?.parent[nameKey] }}
          </span>

        </section>

        <svg class="w-5 h-5 " fill="#6c6c6c" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 24 24">
          <path
            d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z"></path>
        </svg>
      </li> -->
      
      
    <!-- </ul> -->
  </form>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from "@/store/Modules/global.js";
import { constructQueryString ,MAINROLES} from "@/helpers";


export default {
  name: 'MainHeaderSearch',
  props: ['showSearch', 'closeSearchBar'],
  setup() {


    const global = useGlobalStore()
    return {
      global,

    };
  },
  data() {
    return {
      searchInpt: '', //this mirror to search query in url path
      isLoading:false,
      suggestions:[],
      cachingSuggestions:{},
      showSuggestionsList: false,
      isLoadingSuggestions:false,
      //abortController:null
    };
  },
  watch: {
    searchInpt(newVal,oldVal) {
      // const route = useRoute();
     
      // newVal=this.formattedInput(newVal)
      // oldVal=this.formattedInput(oldVal)

      // if (newVal == '' && route.path == this.ROUTESNAMES.user.search) {
      //   //if clear search input and in search page ---> clear seach query string from url
      //   this.$router.replace({ query: null });
      // }
      if(newVal){
  this.global.changeSearchInputStatus('typing')

}else{
  this.global.changeSearchInputStatus('start')

}

      this.handleSuggestions(newVal)
    },
    cachingSuggestions:{
      handler(){
      },deep:true
    },
    '$route.path'(newPath) {

    if (newPath == '/' ) {
      // this.$nextTick(() => {
        const searchInputRef = this.$refs['searchInput'];
      setTimeout(() => {
        searchInputRef.value = ''; // Clear the input value

      }, 10);
       
      // });
    }
  },
  },
  computed: {
    ...mapState(useGlobalStore, ['getStoredUserGeoLocation']),
  },
  methods: {
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.global.setSearchInputValue(event.target.value).then(()=>{
          this.$router.go(0);
        });
      }
    },
    debounce(callback, timer = 1, immediate = true) {
      if (typeof callback === 'function')
        return (...args) => {
          if (immediate) {
            return callback(...args);
          } else {
            clearTimeout(this.timeoutVal);
            this.timeoutVal = setTimeout(() => {
              return callback(...args);
            }, Number(timer));
          }
        };
    },
    navigateToSearchPage(){
      if(this.$route.path != '/search'){
        this.$router.push('/search')
      }
    },
    handleSuggestions(searchInpt=''){
      this.debounce(
        () =>this.getSuggestions(searchInpt),
        900,
        false
      )();
    },
    async getSuggestions(searchInpt='') {
    //validations searchInpt
      // if(!searchInpt || searchInpt.length<3 ){
      //   this.suggestions=[];
      //   return 
      // }
      // if(this.cachingSuggestions[searchInpt]){
      //   this.suggestions = this.cachingSuggestions[searchInpt]
      //   return
      // }
      //this.abortController=new AbortController();

      this.isLoadingSuggestions=true
      try {
        // const { lat = '', lng = '' } = this.getStoredUserGeoLocation;
        // const queryString = constructQueryString([{key: "search", value: encodeURIComponent(searchInpt)}, ...((lat && lng) ? [{ key: "location", value: `${lat},${lng}` }] : [])]);
       
        const res = await this.makeRequest({
          ...(this.isUserLoggedIn && {owner: MAINROLES.user}),
          includeUID: true,
          url: `${this.APIREQUESTS.user.getSuggestions.url}?search=${encodeURIComponent(searchInpt)}`,
          method: this.APIREQUESTS.user.getSuggestions.method,
          //abortControllerSignal:this.abortController.signal
        });
        //check response
        if (!res.status) {
          //not ok
          // this.notify({ type: 'error', msg: res?.message || this.$t('general.failed') });
        } else {
          //ok
          this.global.setNewSearchSuggestionData(res?.data)
if(searchInpt){
  this.global.changeSearchInputStatus('typing')

}else{
  this.global.changeSearchInputStatus('start')

}

          // if(queryString)


          // this.suggestions = res?.data || [];
          if(this.suggestions.length){
            this.suggestions=this.suggestions.map(suggestion=>({...suggestion,search:searchInpt}))
          }
          this.cachingSuggestions[searchInpt]=this.suggestions
        }
      } catch (err) {
        console.error("error in the search:", err);
        // this.notify({ type: 'error', msg: err?.data?.message });
      } finally {
        this.isLoadingSuggestions=false
      }
    },
    // redirectToFilterPage(suggestionItem = {}) {
    //   try {
    //     let queryToClientObj = {
    //       ...(suggestionItem.search && { search: encodeURIComponent(suggestionItem?.search)}),
    //       ...(suggestionItem?.parent?.id && { main_category_id: suggestionItem?.parent?.id }),
    //       ...(suggestionItem.id && { sub_category_id: suggestionItem?.id }),
    //       sort_by: 'date',
    //       sort_type: 'asc',
    //       from: 'list',
    //     };
    //     let queryToClientStr = Object.entries(queryToClientObj)
    //       .map((item, i) => (i == 0 ? item.join('=') : `&${item.join('=')}`))
    //       .join(''); //new URLSearchParams(queryToClientObj).toString()
    //     let encodedQuery = btoa(encodeURIComponent(queryToClientStr));
    //     this.$router.push(`${this.ROUTESNAMES.user.products}?${encodedQuery}`);
    //   } catch {
    //     // this.$router.push(`${this.ROUTESNAMES.user.products}`) ;
    //   }
    // },


 
//     async getSearchData() {
//   try {
//     const res = await this.makeRequest({
//       ...(this.isUserLoggedIn && { owner: MAINROLES.user }),
//       includeUID: true,
//       url: `${this.APIREQUESTS.user.getProducts.url}?with_ads=0&search=${this.searchInpt}`,
//       method: this.APIREQUESTS.user.getProducts.method,
//     });

//     // Check response
//     if (!res.status) {
//       // If not OK, notify the user
//       this.notify({ type: "error", msg: res?.message || this.$t('general.failed') });
//     } else {
//       // Store the data and navigate to the new route
//       this.global.setNewSearchData(res.data);
//       this.$router.push(`${this.ROUTESNAMES.user.searchWithFilter}?search=${this.searchInpt}`);
//     }
//   } catch (err) {
//     console.error(err);
//     this.notify({ type: "error", msg: err?.data?.message });
//   } finally {
//     // Final cleanup, executed whether success or failure

//     // Store all data in Pinia
//     this.global.updateSearchpageData({ ...this.$data });
//   }
// },


  



    async submitSearch() {
this.isLoading = true

this.$router.push(`${this.ROUTESNAMES.user.searchWithFilter}?search=${this.searchInpt}`);

  //  await   this.getSearchData();
  //  await   this.getCategories();
   this.isLoading = false;
      this.closeSearchBar();
      this.showSuggestionsList = false
      //if click search and not empty -->attached to url
      // let formattedSearchInpt = this.formattedInput(this.searchInpt)
      // formattedSearchInpt && this.$router.replace(`${this.ROUTESNAMES.user.search}?search=${encodeURIComponent(formattedSearchInpt)}`);
       },





    // autoInputFocus() {
    //   // this function is being used by the parent component
    //   const searchInputRef = this.$refs['searchInput'];
    //   if (searchInputRef) {
    //     this.$nextTick(() => {
    //       searchInputRef.focus();
    //     });
    //   }
    // },
    formattedInput(input) {
      //convert To SingleSpace and trim sapces at the end of sentence
      return input? input.replace(/\s+/g, ' ').trim() :'';
    }
  },
  mounted() {
    const route = useRoute();
    this.searchInpt = this.$route.query.search || '';
  },

};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0.7em;
}

::-webkit-scrollbar-track {
  border-radius: 100px;
  background-color: rgba(169, 169, 169, 0.234);
}
::-webkit-scrollbar-thumb {
  background-color: #a9a9a9cc;
  /*background-image: linear-gradient(180deg, #453ed1 0%, #708ad4 99%);*/
  border-radius: 100px; /*thumb border-radius*/

  background-clip: content-box; /*to make border control thumb width*/
  border: 2px solid transparent; /*thumb width*/
}
</style>
